import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import Loader from '../../elements/Loader';
import ModalActionButton from '../../elements/ModalActionButton';
import ArrowDownTrayIcon from '../../elements/icons/ArrowDownTrayIcon';
import ChevronIcon from '../../elements/icons/ChevronIcon';
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import InlinePreloader from '../../elements/InlinePreloader';

const NewAcademicTranscript = ({student, close}) => {
    const [transcript, setTranscript] = useState(null)
    const [loading, setLoading] = useState(true)
    const [openResults, setOpenResults] = useState({ 0: true })
    const dispatch = useDispatch()

    const toggleResult = (index) => {
        setOpenResults(previous => ({ ...previous, [index]: !previous[index] }))
    }

    useEffect(() => {
        const generateTranscript = async () => {
            try {
                setLoading(true);
                const headers = authHeader()
                const response = await axios.get(`${baseUrl}/academic-transcripts/student/${student._id}/generate`, { headers })
                setTranscript(response.data.data)
                
            } catch (error) {
                dispatch({
                    type: ERROR,
                    error
                })
            } finally {
                setLoading(false);
            }
           
        }

        generateTranscript();

        return () => {}

    }, [student._id, dispatch])

    const [processing, setProcessing] = useState(false)
    const [saveAndDownload, setSaveAndDownload] = useState(false)

    const saveTranscript = async (shouldDownload = saveAndDownload) => {
        try {
            setSaveAndDownload(shouldDownload);
            setProcessing(true);
            const headers = authHeader()
            await axios.post(`${baseUrl}/academic-transcripts/student/${student._id}/confirm`, transcript, { headers })

            if(shouldDownload) {
                await downloadTranscript();
            } else {
                dispatch({
                    type: SET_SUCCESS,
                    payload: "Transcript saved successfully"
                })
            }

            close()
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        } finally {
            setProcessing(false);
        }
    }

    const downloadTranscript = async () => {
        try {
            const headers = authHeader()
            const response = await axios.get(`${baseUrl}/academic-transcripts/student/${student._id}/download`, { headers, responseType: 'blob' })
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `transcript_${student._id}.pdf`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            setSaveAndDownload(false)
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        }
    }


    return (
        <>
            <div className="w-full max-h-[85vh] overflow-hidden flex flex-col">
                <div className='pb-3 mb-2 flex-shrink-0'>
                    <div className="w-full mx-auto">
                        <div className='w-full flex items-start justify-between'>
                            <div className='w-2/3'>
                                <h4 className='font-medium text-lg text-gray-600'>Student Academic Transcript</h4>
                                <p className='text-gray-600 text-sm'>
                                    All academic records for this student are displayed below.
                                </p>
                            </div>
                            <div className='w-full flex flex-row-reverse gap-x-[5px]'>
                                {/* {<button onClick={()=>{}} disabled={false} className='rounded-[8px] w-max text-sm text-gray-600 transition duration-200 px-4 py-3 bg-gray-100 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2 font-space-grotesk font-semibold'>
                                    <span className='flex items-center gap-x-2'>
                                        <ArrowDownTrayIcon className='w-5 h-5' />
                                        Download Transcript (.pdf)
                                    </span>
                                </button>}

                                {<button onClick={()=>{}} disabled={false} className='rounded-[8px] w-max text-sm text-gray-600 transition duration-200 px-4 py-3 bg-gray-100 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2 font-space-grotesk font-semibold'>
                                    <span className='flex items-center gap-x-2'>
                                        <EmailAtIcon className='w-5 h-5' />
                                        Send as Email
                                    </span>
                                </button>} */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='overflow-y-auto flex-1'>
                    {loading ? 
                        <Loader />
                    : !transcript || !transcript.results?.length ? (
                        <div className='py-12 text-center text-sm text-gray-400'>No academic records found for this student.</div>
                    ) : (
                        <div className="w-full flex flex-col gap-y-6">
                            <div className='w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
                                <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Student</p><p className='text-sm font-semibold text-gray-700 mt-1'>{transcript.student?.fullName || student.fullName}</p></div>
                                <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Admission Number</p><p className='text-sm font-semibold text-gray-700 mt-1'>{transcript.student?.admissionNumber || 'Not available'}</p></div>
                                <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Number of Terms</p><p className='text-sm font-semibold text-gray-700 mt-1'>{transcript.results.length}</p></div>
                                <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Overall Average</p><p className='text-sm font-semibold text-gray-700 mt-1'>{transcript.overallAverage?.toFixed(2) || '0.00'}%</p></div>
                            </div>

                            <div className='w-full flex flex-col gap-y-4'>
                                {transcript.results.map((result, index) => {
                                    const isOpen = !!openResults[index]
                                    const subjectBreakdown = result.subjectBreakdown || []
                                    return (
                                        <div key={result.resultId || index} className='w-full border border-gray-100 rounded-[8px] overflow-hidden'>
                                            <button onClick={() => toggleResult(index)} className='w-full flex items-center justify-between px-4 py-3 bg-gray-50 text-left'>
                                                <span className='flex items-center gap-x-2 text-sm text-gray-600 font-space-grotesk font-medium'>
                                                    <ChevronIcon className={`w-4 h-4 transition duration-200 ${isOpen ? 'rotate-[270deg]' : 'rotate-180'}`} />
                                                    {result.term?.name || result.termName || `Term Result ${index + 1}`}
                                                </span>
                                                <span className='flex items-center gap-x-4 text-xs text-gray-500 font-outfit'>
                                                    <span>Total: {result.total?.toFixed(2) || '0.00'}</span>
                                                    <span>Average: {result.average?.toFixed(2) || '0.00'}%</span>
                                                </span>
                                            </button>
                                            {isOpen && (
                                                <div className='w-full overflow-x-auto'>
                                                    <table className='w-full text-sm'>
                                                        <thead><tr className='bg-white text-left text-xs text-gray-500 font-space-grotesk border-b border-gray-100'><th className='px-4 py-3 font-medium'>Subject</th><th className='px-4 py-3 font-medium'>Assessments</th><th className='px-4 py-3 font-medium'>Total Score</th><th className='px-4 py-3 font-medium'>Average</th><th className='px-4 py-3 font-medium'>Grade</th><th className='px-4 py-3 font-medium'>Status</th></tr></thead>
                                                        <tbody className='divide-y divide-gray-100'>{subjectBreakdown.map(entry => <tr key={entry._id}>
                                                            <td className='px-4 py-3 text-gray-700 font-medium'>{entry.subject?.name || entry.subject}</td>
                                                            <td className='px-4 py-3 text-gray-500'>{entry.uploadedAssessmentCount} of {entry.assessmentCount}</td>
                                                            <td className='px-4 py-3 text-gray-500'>{entry.totalScore?.toFixed(2)}</td>
                                                            <td className='px-4 py-3 text-gray-500'>{entry.averageScore?.toFixed(2)}%</td>
                                                            <td className='px-4 py-3 text-gray-500'>{entry.grade}</td>
                                                            <td className='px-4 py-3'><span className={`inline-block text-xs px-2 py-1 rounded font-outfit ${entry.passingGrade ? 'bg-green-600 text-green-800 bg-opacity-10' : 'bg-red-600 text-red-800 bg-opacity-10'}`}>{entry.passingGrade ? 'Passing' : 'Failing'}</span></td>
                                                        </tr>)}</tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>

                {!loading && transcript && <div className="mt-8 flex flex-row-reverse gap-x-4 flex-shrink-0">
                <div className="w-[200px]">
                    <ModalActionButton
                        buttonLabel={'Only Save Transcript'}
                        buttonAction={()=>{saveTranscript()}}
                        processing={processing && !saveAndDownload}
                    />
                </div>

                <button onClick={()=>{
                    setSaveAndDownload(true)
                    saveTranscript(true)
                }} disabled={false} className='rounded-[8px] w-[350px] text-sm text-gray-600 transition duration-200 px-4 py-3 bg-gray-100 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2 font-space-grotesk font-semibold'>
                    {processing && saveAndDownload ? 
                        <InlinePreloader />
                        :
                        <span className='flex items-center gap-x-2'>
                            <ArrowDownTrayIcon className='w-5 h-5' />
                            Save & Download Transcript (.pdf)
                        </span>
                    }
                </button>
                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-sm font-medium bg-transparent border border-transparent rounded-xl font-space-grotesk hover:bg-opacity-10 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>}
            </div>
        </>
    )
}

export default NewAcademicTranscript